import type { CandidateVacancy } from '../types';
import { mockCandidateCurrency } from './mockCandidateCurrency';

type CandidateTariff = NonNullable<CandidateVacancy['tariffs']>[number];

export function mockCandidateTariff(
  overrides: Partial<CandidateTariff> = {}
): CandidateTariff {
  return {
    id: 1,
    name: 'Candidate confirmation',
    description: 'Candidate selection based on their resume',
    price: 0,
    currency: mockCandidateCurrency(),
    ...overrides,
  };
}
